import { RadialLoader } from '../../../svgs';
import * as Styled from './LoadingSpinner.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingSpinner = () => /*#__PURE__*/_jsx(Styled.LoadingSpinner, {
  role: "status",
  children: /*#__PURE__*/_jsx(RadialLoader, {})
});